import { Text } from "@react-three/drei";
import React from "react";
import * as THREE from "three";
import { textMeshMaterial } from "../Open/XRImagePop";
import { useFrame } from "@react-three/fiber";

const XRHotspotLabel = (props: { hoverState: boolean; children: string }) => {
  const groupRef = React.useRef<THREE.Group>(null);
  const textRef = React.useRef();
  const bgRef = React.useRef(new THREE.Mesh());

  const { hoverState } = props;

  useFrame(() => {
    if (hoverState) {
      groupRef.current?.scale.lerp(one, 0.1);
    } else groupRef.current?.scale.lerp(zero, 0.1);

    // CALCULATING TEXT BOUNDING BOX AND APPLYING IT TO BACKGROUND LABEL

    if (textRef.current && bgRef.current) {
      // @ts-expect-error
      const finite: number = textRef.current.geometry?.boundingBox.max.length();
      if (isFinite(finite)) {
        // @ts-expect-error
        const box: THREE.Box3 = textRef.current.geometry?.boundingBox;

        box.getSize(size3);

        bgRef.current.scale.copy(size3.add(labelPadding));
        bgRef.current.position.y = -bgRef.current.scale.y / 2;
      }
    }
  });

  return (
    <group position={[0, -20, 0]} ref={groupRef} name="label" scale={0}>
      <Text
        ref={textRef}
        fontWeight={900}
        material={textMeshMaterial}
        outlineColor={"white"}
        outlineOpacity={0.25}
        outlineWidth={"5%"}
        outlineBlur={"5%"}
        fontSize={6}
        lineHeight={1.5}
        position={[0, -1, 5]}
        overflowWrap="break-word"
        textAlign="center"
        maxWidth={100}
        anchorY={"top"}
      >
        {props.children}
      </Text>

      <mesh
        position={[0, 0, -5]}
        ref={bgRef}
        // position={[10, 0, 1]}
        geometry={labelGeometry}
        //   ref={props.bgRef}
        material={labelMaterial}
      />
    </group>
  );
};

export default XRHotspotLabel;

export const labelMaterial = new THREE.MeshBasicMaterial({
  color: "#0c4a6e",
  transparent: true,
  depthTest: false,
  opacity: 0.75,
});
const labelGeometry = new THREE.PlaneGeometry();

const one = new THREE.Vector3(1, 1, 1);
const zero = new THREE.Vector3(0, 0, 0);
const size3 = new THREE.Vector3();
const labelPadding = new THREE.Vector3(5, 5, 1);

// if (textRef.current && labelRef.current) {
//     const finite: number =
//       // @ts-expect-error
//       textRef.current.geometry?.boundingBox.max.length();

//     if (isFinite(finite) && !labelRef.current.geometry.index) {
//       // @ts-expect-error

//       const box: THREE.Box3 = textRef.current.geometry?.boundingBox;

//       const size3 = new THREE.Vector3();

//       box.getSize(size3);
//       size3.multiplyScalar(1.2);

//       labelRef.current.geometry = new THREE.PlaneGeometry(size3.x, size3.y);

//       return;
//     } else return;
//   }
